// extracted by mini-css-extract-plugin
export default {"modal":"AddHistoryModal_modal__YZjV1","previewText":"AddHistoryModal_previewText__7nOZ4","previewRow":"AddHistoryModal_previewRow__ux9Bq"};